export default "__VITE_ASSET__a0e4e293__"